module.exports = __webpack_public_path__ + "images/greenflux_small94f459e56b3534b5dcc38cb035cd848b.png";